import { wixSdkAdapter } from './wixSdkAdapter';
import { win } from './win';

interface QueryHeader {
  [headerName: string]: string;
}

export const getConsentPolicyHeader = (): QueryHeader => {
  if (
    wixSdkAdapter.isAvailable() &&
    typeof wixSdkAdapter.Wix.Utils?._getConsentPolicyHeader === 'function'
  ) {
    try {
      return wixSdkAdapter.Wix.Utils._getConsentPolicyHeader();
    } catch (error) {
      console.warn(
        `PaymentsWidget: failed to get consent policy from Wix JS-SDK`,
        error
      );
    }
  }

  if (typeof win.consentPolicyManager?._getConsentPolicyHeader === 'function') {
    try {
      return win.consentPolicyManager._getConsentPolicyHeader();
    } catch (error) {
      console.warn(
        `PaymentsWidget: failed to get consent policy from window.consentPolicyManager`,
        error
      );
    }
  }
};

/** Will be used once we'll need to update user consent dynamically (ATM it's an edge case that can be ignored) */
// const customChangeEvent: string = 'change';
// const nativeBrowserPolicyChangedEvent: string = 'consentPolicyChanged';
// const isWixOnConsentPolicyChangedAvailable = (): boolean =>
//   wixSdkAdapter.isAvailable() &&
//   typeof wixSdkAdapter.Wix.Utils?.onConsentPolicyChanged === 'function';

// class ConsentPolicyManager {
//   private emitter = new EventEmitter();
//   private isDestroyed: boolean = false;
//
//   constructor() {
//     this.listenPolicyChange();
//   }
//
//   private policyChangeListener = () => {
//     if (!this.isDestroyed) {
//       this.emitter.emit(customChangeEvent, this.getConsentPolicyHeader());
//     }
//   };
//
//   private listenPolicyChange() {
//     if (isWixOnConsentPolicyChangedAvailable()) {
//       wixSdkAdapter.Wix.Utils.onConsentPolicyChanged(this.policyChangeListener);
//     } else {
//       win.addEventListener(
//         nativeBrowserPolicyChangedEvent,
//         this.policyChangeListener
//       );
//     }
//   }
//
//   private unlistenPolicyChange() {
//     if (!isWixOnConsentPolicyChangedAvailable()) {
//       win.removeEventListener(
//         nativeBrowserPolicyChangedEvent,
//         this.policyChangeListener
//       );
//     } // ATM there is no way to unsubscribe from JS-SDK's onConsentPolicyChanged, thus using this.isDestroyed
//   }
//
//   public getConsentPolicyHeader(): QueryHeader {
//     return getConsentPolicyHeader();
//   }
//
//   public addListener(cb: (contentPolicyHeader: QueryHeader) => void) {
//     this.emitter.addListener(customChangeEvent, cb);
//   }
//
//   public removeListener(cb: (contentPolicyHeader: QueryHeader) => void) {
//     this.emitter.removeListener(customChangeEvent, cb);
//   }
//
//   public destroy() {
//     if (this.isDestroyed) {
//       console.warn(`consentPolicyManager was already destroyed`);
//       return;
//     }
//     this.isDestroyed = true;
//     this.emitter.removeAllListeners();
//     this.unlistenPolicyChange();
//   }
// }
